import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  controlList: [
    { id: 1212214214, grop: 'fkakfwoDFKWEOFE239439', time: 'вт 22.10.2024' },
    { id: 12123214214, grop: 'fkakfwoDFKWEOFE2393439', time: 'ср 23.10.2024' },
    { id: 12122414214, grop: 'fkakfwoDFKWEOFE2393439', time: 'чт 22.10.2024' },
  ],
  IndexRenderDay: 0,
  value: [],
};

const controlSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    // Додає групу
    addControlListRedux(state, { payload }) {
      state.statistics = payload;
      // console.log(payload);
    },
  },
});

export const { addControlListRedux } = controlSlice.actions;

export default controlSlice.reducer;
